import "./AppLoading.scss";

const AppLoading = () => {
  return (
    <div className="loading-container">
      <div className="spinner"></div>
      <p>Loading...</p>
    </div>
  );
};

export default AppLoading;
